<template>
  <component :is="this.tag">
    <img
      v-if="show"
      @error="imgError"
      :src="`/static/images/flags/${flagLang}`"
      :alt="parsedLang"
      :title="parsedLang"
    />
    <span v-if="value">
      {{ value }}
    </span>
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'LangString',
  props: {
    lang: String,
    value: String,
    tag: {
      type: String,
      default: 'span'
    }
  },
  data() {
    return {
      show: true
    }
  },
  computed: {
    parsedLang() {
      if (this.lang && this.lang.length >= 2) {
        return this.lang.substring(0, 2)
      }
    },
    flagLang() {
      var flag
      if (this.lang && this.lang.length > 2) {
        flag = this.lang.substr(3, 2)
      } else if (this.lang.length === 2) {
        flag = this.lang
      }

      flag = flag.toLowerCase()
      switch (flag) {
        case 'en':
          return 'gb.png'
        default:
          return `${flag}.png`
      }
    }
  },
  methods: {
    imgError() {
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LangString.vue